/* eslint-disable no-unused-vars */
import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { Tabs, Typography } from 'foundations-library/components'
import PasswordManagement from './password-management'
import SessionManagement from './session-management/Index'
import MFABanner from '../banners/MFA'

const jss = () => ({
    headerBar: {
        padding: '14px',
        borderColor: '#e0e0e0',
        borderStyle: 'solid',
        borderWidth: '0 0 1px 0',
        backgroundColor: '#f5f5f5'
    },
    passAndSess: {
        maxWidth: '900px',
        margin: '40px auto 0 auto',
        '& .password-management': {
            maxWidth: '400px',
            margin: 'auto'
        }
    },
    tabContent: {
        marginTop: '40px'
    }
})

const useStyles = makeStyles(jss)
const tabs = {
    password: {
        component: PasswordManagement,
        text: 'Password settings'
    },
    session: {
        component: SessionManagement,
        text: 'Active sessions'
    }
}

/**
 *
 */
const PasswordAndSessionManagement = (): JSX.Element => {
    const styles = useStyles()
    const [activeTab, setActiveTab] = useState('password')

    return (
        <>
            <div className={styles.headerBar}>
                <Typography variant='h8' color='neutral-900'>Password management</Typography>
            </div>
            <div className={styles.passAndSess}>
                {/* <MFABanner /> */}
                {/* <Tabs
                    value={activeTab}
                    color='neutral'
                    onChange={setActiveTab}
                    items={Object.entries(tabs).map(([key, { text }]) => ({ value: key, text }))}
                    data-testid='password-and-session-management-tabs'
                />

                <div className={styles.tabContent}>
                    {Object.entries(tabs).map(([key, { component: Component }]) => {
                        if (key !== activeTab) return null
                        return <Component key={key} />
                    })}
                </div> */}
                <PasswordManagement />
            </div>
        </>
    )
}

export default PasswordAndSessionManagement
